import * as React from "react"
import includes from "lodash.includes"
import styled from "styled-components"
import { FetchSingleListingUtilities } from "../../generated/graphql"
import theme from "../../theme/"
import Text from "../text"
import Row from "../row"
import Box from "../box"
import Column from "../column"
import { Utilities } from "../../constants/utilities.constant"

const Icon = styled.img`
  width: 32px;
  height: 32px;
  margin-bottom: ${theme.space[2]}px;
`

const Utilitie = styled(Column as any)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  margin-bottom: ${theme.space[4]}px;
  margin-right: ${theme.space[4]}px;
`

const HeadingH1 = styled.h2`
  text-decoration: none;
  margin-bottom: 18px;
  color: rgb(60, 66, 64);
  font-size: 32px;
  font-weight: 600;
`

interface Props {
  utilities?: FetchSingleListingUtilities | null
}

const SingleListingUtilitiesSection = ({ utilities }: Props) => {
  let _utilities
  let hasAtLeastOne = false

  if (utilities !== null && utilities !== undefined) {
    _utilities = (Object as any).keys(utilities)
    let _values = (Object as any).values(utilities)
    hasAtLeastOne = includes(_values, true)
  }

  return (
    <Box flexDirection="column" mb={[4]}>
      <HeadingH1>Utilities Included</HeadingH1>
      <Row flexWrap={"wrap"}>
        {_utilities?.map((key: string) => {
          if (utilities && utilities[key] === true) {
            const [utilitie] = Utilities.filter(elem => key === elem.value)
            return (
              <Utilitie key={"utilities-" + utilitie.value}>
                {utilitie.icon && <Icon src={utilitie.icon} alt={utilitie.name} />}
                <Text fontSize={18} color={theme.colors.darkGrey} lineHeight={1.4}>
                  {utilitie.name}
                </Text>
              </Utilitie>
            )
          } else {
            return null
          }
        })}
        {!hasAtLeastOne && (
          <Text fontSize={18} color={theme.colors.darkGrey} lineHeight={1.4}>
            Please inquire about details
          </Text>
        )}
      </Row>
    </Box>
  )
}

export default SingleListingUtilitiesSection
